/* --------------------------------------------------------------------------
	Media Top
-------------------------------------------------------------------------- */

	"use strict";
	var $ = jQuery;
	import 'fastdom';
	var $mediaTop,
	$videoToggle,
	VideoPlayer;

	function initMediaTop() {
		$mediaTop = $(".js-media-top-video-wrapper");
		if ( $mediaTop.length ) {
			$videoToggle = $(".js-media-top-video-control");
			VideoPlayer = new Vimeo.Player($mediaTop.find(".js-media-top-video-iframe"));
			
			bindUI();
			$(window).on('resize', onResize);
			onResize();
		}
	}

	function bindUI() {
		$videoToggle.on("click", toggleVideo);
	}

	function onResize() {
		var css;
		fastdom.measure(function () {
			var mediaWidth = $mediaTop.width();
			var mediaHeight = $mediaTop.height();
			var aspectRatio = mediaWidth / mediaHeight;

			if (aspectRatio >= 1.7777) {
				// 16:9 or wider
				css = {
					"width": "100%",
					"height": mediaWidth / 1.7777
				};
			} else {
				// More square or portait
				css = {
					"width": mediaHeight * 1.7777,
                    "height": "100%"
				};
			}
		});

		fastdom.mutate(function () {
			$mediaTop
                .find(".js-media-top-video-iframe")
                .css(css);
		})
	}

	function toggleVideo() {
		if( $videoToggle.hasClass("paused") ) {
			VideoPlayer.play();
			$videoToggle.find(".media_top_video_control_label").text("Pause Video");
			$videoToggle.removeClass("paused");
		} else {
			VideoPlayer.pause();
			$videoToggle.find(".media_top_video_control_label").text("Play it");
			$videoToggle.addClass("paused");
		}
	}

	$(initMediaTop);
